import React from 'react'
import Helmet from 'react-helmet'
import { LOCALES } from '../config'
import { LocaleService } from '../services/locale-service'
import { Script } from 'gatsby'
const canonicalMap = {
  home: '/',
  product1: '/products/file/',
  product2: '/products/sdk/',
  product3: '/products/vpn/',
  product4: '/products/ftp/',
  product5: '/products/ssh/',
  solution7: '/solutions/data-collaboration/',
  solution6: '/solutions/data-distribution/',
  solution5: '/solutions/data-migration/',
  solution4: '/solutions/data-sync/',
  solution3: '/solutions/large-file-transfer/',
  solution2: '/solutions/multi-transfer/',
  solution1: '/solutions/data-transfer/',
  government: '/solutions/industry-government/',
  media: '/solutions/industry-media/',
  gaming: '/solutions/industry-gaming/',
  marine: '/solutions/industry-marine/',
  tech: '/solutions/industry-tech/',
  ad: '/solutions/industry-ad/',
  financing: '/solutions/industry-financing/',
  gene: '/solutions/industry-gene/',
  car: '/solutions/industry-car/',
  manufacturing: '/solutions/industry-manufacturing/',
  internet: '/solutions/industry-internet/',
  moive: '/solutions/industry-moive/',
  pricing: '/pricing/',
  pay: '/pay-traffic/',
  example: '/casestudies/',
  about: '/about-us/',
  apply: '/apply/',
  agent: '/partners/',
  'get-license': '/get-license/',
  enterprise: '/enterprise/',
}
const Scripts = ({ pageType, path, lang }) => {
  let canonical
  if (canonicalMap[pageType]) {
    canonical = `${canonicalMap[pageType]}`
  }
  if (path) {
    canonical = path.endsWith('/') || path.endsWith('.html') ? path : path + '/'
  }
  const isHomePage = pageType === 'home'
  const langs = Object.values(LOCALES)
  const currentLangPrefix = lang ? `/${lang}/` : '/'
  const purePath = canonical.replace(currentLangPrefix, '/')
  return (
    <Helmet>
      {/* SNS meta */}
      <meta
        name='viewport'
        content='width=device-width, initial-scale=1, shrink-to-fit=no, user-scalable=no'
        data-react-helmet='true'
      />
      <link rel='icon' href='https://www.raysync.io/favicon.ico' />
      <meta name='robots' content='INDEX,FOLLOW' />
      <meta property='og:type' content='website' />
      <meta property='og:url' content={`https://www.raysync.io${canonical}`} />
      <meta property='og:site_name' content='Raysync' />
      <meta property='fb:app_id' content='1505841156187794' />
      <meta property='twitter:account_id' content='1240942611742916608' />
      <meta name='twitter:site' content='@Raysync' />
      <meta name='twitter:creator' content='@Raysync' />
      {canonical && <link rel='canonical' href={`https://www.raysync.io${canonical}`} />}
      <link rel='alternate' hreflang='x-default' href={`https://www.raysync.io${purePath}`} />
      {canonical &&
        langs.map(language => {
          return (
            <link
              key={language}
              rel='alternate'
              hreflang={language === LOCALES.EN ? 'en' : language}
              href={`https://www.raysync.io${language === LOCALES.EN ? '' : `/${language}`}${purePath}`}
            />
          )
        })}
      <script>{`var meta = document.querySelector('meta[name="viewport"]');
        meta && meta.setAttribute('content','width=device-width, initial-scale=1, shrink-to-fit=no, user-scalable=no')`}</script>
      {isHomePage && (
        <script type='application/ld+json'>
          {`{
            "@context": "https://schema.org",
            "@type": "SoftwareApplication",
            "name": "Raysync",
            "operatingSystem": [
              "Windows Server 2008+",
              "Windows 7+",
              "Linux (CentOS 6.5+, Ubuntu 14+, Debian 12+)",
              "macOS 10.11+",
              "Android",
              "iOS"
            ],
            "applicationCategory": "BusinessApplication",
            "featureList": [
              "High-speed large file transfer",
              "UDP-based transfer protocol",
              "Up to 100x faster than FTP",
              "Bandwidth utilization over 96%",
              "Secure file transfer (AES-256 & TLS encryption)",
              "Peer-to-peer transfer",
              "File synchronization (one-way/two-way, scheduled)",
              "Admin management portal",
              "User management",
              "Real-time logs and audit trails",
              "Cross-platform support",
              "SDK & API integration",
              "File sharing with link, password, and expiration",
              "Anti-virus scanning (upload)",
              "2FA verification",
              "Operation & transfer log for audit",
              "User group shared folder",
              "Online preview and playback",
              "File auto-sync",
              "Custom branding",
              "Watermark for online video preview",
              "Breakpoint resume",
              "Intelligent compression",
              "Load balancing deployment support"
            ],
            "offers": [
              {
                "@type": "Offer",
                "name": "Raysync Cloud",
                "description": "Cloud-based file transfer solution.",
                "priceSpecification": {
                  "@type": "UnitPriceSpecification",
                  "price": 99,
                  "priceCurrency": "USD",
                  "billingIncrement": 1,
                  "billingDuration": "Monthly"
                },
                "url": "https://www.raysync.io/pricing/"
              },
              {
                "@type": "Offer",
                "name": "Raysync SMB",
                "description": "File transfer solution for small and medium businesses.",
                "priceSpecification": {
                  "@type": "UnitPriceSpecification",
                  "price": 1599,
                  "priceCurrency": "USD",
                  "billingIncrement": 1,
                  "billingDuration": "Annually"
                },
                "url": "https://www.raysync.io/pricing/"
              },
              {
                "@type": "Offer",
                "name": "Raysync Enterprise",
                "description": "Customizable file transfer solution for large enterprises.",
                "priceSpecification": {
                  "@type": "UnitPriceSpecification",
                  "price": "Custom Pricing",
                  "priceCurrency": "USD"
                },
                "url": "https://www.raysync.io/pricing/"
              }
            ],
            "url": "https://www.raysync.io/",
            "description": "Raysync is the ultimate solution for lightning-fast enterprise file transfers. Accelerate your workflows and boost productivity with our cutting-edge technology.",
            "author": {
              "@type": "Organization",
              "name": "RAYWING PTE. LTD."
            },
            "datePublished": "2017-01-01",
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": 5,
              "ratingCount": 4
            },
            "screenshot": [
              "https://www.raysync.io/static/b2e3aa8f8288ef949d064e84d9fa4e0d/73da6/banner_img.webp"
              ]
        }`}
        </script>
      )}
    </Helmet>
  )
}
export default Scripts
